import React from 'react';
import { useSelector } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { Typography } from '@ha/dsl';
import { CanonicalCollections } from 'ha/constants/SearchPageCollections';

import {
  getLocation,
  isSearchByPartner as isSearchByPartnerSelector,
  getNumberOfListings,
  getIsAdvertiserSearch,
  getAdvertiserName,
} from '../selectors';
import { getCollection } from '../selectors/filterSelectors';

interface Props {
  className?: string;
}

export const SearchLocationTitle: React.FC<Props> = ({ className }) => {
  const { T } = useIntl();

  const isAdvertiserSearch = useSelector(getIsAdvertiserSearch);
  const advertiserName = useSelector(getAdvertiserName);
  const total = useSelector(getNumberOfListings);
  const canonicalCollection = useSelector(getCollection);
  const placeName = useSelector(getLocation);
  const isSearchByPartner = useSelector(isSearchByPartnerSelector);

  const params = {
    placeName,
    total,
    kinds: {
      [CanonicalCollections.ApartmentForRent]: T(
        'seo_search_kinds_apartment_for_rent',
      ),
      [CanonicalCollections.PrivateRoomForRent]: T(
        'seo_search_kinds_private_room_for_rent',
      ),
      [CanonicalCollections.SharedRoomForRent]: T(
        'seo_search_kinds_shared_room_for_rent',
      ),
      [CanonicalCollections.StudioForRent]: T(
        'seo_search_kinds_studio_for_rent',
      ),
      [CanonicalCollections.CheapAccommodation]: T(
        'seo_search_kinds_cheap_accommodation',
      ),
      [CanonicalCollections.FurnishedApartments]: T(
        'seo_search_kinds_furnished_apartments',
      ),
      [CanonicalCollections.StudentAccommodation]: T(
        'seo_search_kinds_student_accommodation',
      ),
      [CanonicalCollections.LongTermRentals]: T(
        'seo_search_kinds_long_term_rentals',
      ),
      [CanonicalCollections.OneBedroomApartments]: T(
        'seo_search_kinds_one_bedroom_apartments',
      ),
      [CanonicalCollections.TwoBedroomApartments]: T(
        'seo_search_kinds_two_bedroom_apartments',
      ),
      [CanonicalCollections.StudentRoom]: T('seo_search_kinds_student_room'),
      '': T('seo_search_kinds'),
    }[canonicalCollection],
  };

  let localizedTitle = T(
    '%(total)d %(kinds)s for rent in %(placeName)s',
    params,
  );

  if (isSearchByPartner) {
    localizedTitle = T(
      '%(total)d %(kinds)s for rent near %(placeName)s',
      params,
    );
  }

  if (isAdvertiserSearch) {
    localizedTitle = T('search_advertiser_title', advertiserName, placeName);
  }

  return (
    <Typography.Paragraph component="h1" className={className}>
      {localizedTitle}
    </Typography.Paragraph>
  );
};

export default SearchLocationTitle;
